import { useTranslation } from 'react-i18next';
import pdfFile from '@components/Landing/docs/pdf (2).png';
import { useAppDispatch } from '@hooks/redux';
import { getTarifFileApi } from '@http/global';

function Commissions() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div className='flex justify-center'>
      <div className='lg:w-[1130px] w-full max-lg:px-4'>
        <div className='flex'>
          <div className='py-4 lg:py-8 w-full h-full bg-white mb-12'>
            <div>
              <div>
                <h1 className='text-xl font-medium color-active'>{t('Tariffs')}</h1>
              </div>
            </div>
            <div className='mt-10'>
              <div className='flex flex-col gap-y-10 pl-5 text-base bg-white'>
                <div
                  onClick={e => {
                    e.preventDefault();
                  }}
                  className='flex gap-3  cursor-pointer hover:text-[#69B1FF]'
                >
                  <div className='my-auto '>
                    <img src={pdfFile} alt='' className='w-[35px]' />
                  </div>

                  <p className='color-active'>
                    <a href='#' onClick={() => dispatch(getTarifFileApi({ file_lang: 'tg' }))}>
                      Тарофаҳо барои хизматрасонӣ ба шахсони ҳуқуқӣ ва соҳибкорони инфиродӣ
                    </a>
                  </p>
                </div>
                <div
                  onClick={e => {
                    e.preventDefault();
                  }}
                  className='flex gap-3 cursor-pointer hover:text-[#69B1FF] '
                >
                  <div className='my-auto '>
                    <img src={pdfFile} alt='' className=' w-[35px] ' />
                  </div>
                  <p className='' onClick={() => dispatch(getTarifFileApi({ file_lang: 'ru' }))}>
                    <a href='#'>Тарифы для обслуживания юридических лиц и частных предпринимателей</a>
                  </p>
                </div>
                <div
                  onClick={e => {
                    e.preventDefault();
                  }}
                  className='flex gap-3 mb-5 cursor-pointer hover:text-[#69B1FF]'
                >
                  <div className='flex justify-center my-auto '>
                    <img src={pdfFile} alt='' className='w-[35px]' />
                  </div>
                  <p className='my-auto '>
                    <a href='#' onClick={() => dispatch(getTarifFileApi({ file_lang: 'en' }))}>
                      Rates for Corporate and Sole Proprietor Services
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Commissions;
